<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <brand-form :info="info"/>
      </div>
    </div>
  </section>
</template>

<script>
import brandForm from './Temp/BrandFormTemp.vue'

export default {
  name: 'Tables',
  data () {
    return {
      info: {
        name: '迷客夏',
        type: '飲料'
      }
    }
  },
  components: {
    'brand-form': brandForm
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// UpBrand.vue?20b654de